import { render } from "./item.vue?vue&type=template&id=3f03d7a2"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__